import { Navigate, Outlet, useLocation } from "react-router";
import { routes } from "./routes";
import { UserRolesEnum } from "../enums/userRolesEnum";
import { useUserRole } from "../../hooks/useUserRole";
import { useAuth } from "../../hooks/useAuth";
import CustomSpinner from "../../components/spinner/CustomSpinner";

interface Props {
    roles?: Array<UserRolesEnum>;
}

export const PrivateOutlet = ({ roles }: Props) => {
    const { isAuthenticated, isLoading } = useAuth();
    const { hasRole } = useUserRole();
    const { pathname } = useLocation();

    if (isLoading) {
        return <CustomSpinner isFullScreen={true} hideTextTitle={true} />;
    }

    if (!isAuthenticated) {
        return <Navigate to={routes.login.path} state={{ from: pathname }} replace={true} />;
    }

    if (hasRole([UserRolesEnum.Admin])) {
        return <Outlet />;
    }

    if (roles && !hasRole(roles)) {
        // role not authorized so redirect to home page
        return <Navigate to={{ pathname: "/" }} />;
    }

    return <Outlet />;
};
